var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.227694 1.2984C0.0462206 0.751643 -0.0445162 0.478266 0.0215284 0.309871C0.0788852 0.163628 0.201636 0.0528425 0.352976 0.0107326C0.527238 -0.0377556 0.78991 0.0804462 1.31525 0.31685L18.0325 7.83959C18.5469 8.07104 18.804 8.18676 18.8835 8.34752C18.9526 8.48719 18.9526 8.65107 18.8835 8.79073C18.804 8.9515 18.5469 9.06722 18.0325 9.29867L1.32108 16.8188C0.794148 17.0559 0.530681 17.1745 0.356245 17.1258C0.204764 17.0835 0.0820002 16.9725 0.024841 16.8259C-0.0409797 16.6572 0.0507372 16.3833 0.234171 15.8353L2.56909 8.86063C2.6005 8.7668 2.61621 8.71989 2.62248 8.67188C2.62805 8.62929 2.62811 8.58615 2.62265 8.54354C2.61649 8.49551 2.60091 8.44856 2.56974 8.35466L0.227694 1.2984Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageIcon);
export default __webpack_public_path__ + "static/media/send_message_icon.85a31c864caf68f15d9c479e6a279267.svg";
export { ForwardRef as ReactComponent };